import { createApp } from "vue"

import Related from "./Related.vue"

const app = createApp(Related)

app.mount("#related")